"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Summary = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _components = require("../../containers/ConcernForm/components");
var _concernFormContext = require("../../contexts/concernFormContext");
var _useTranslations = require("../../hooks/useTranslations");
var _SubmitSuccess = require("../SubmitSuccess");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Summary = ()=>{
    const { sentValues } = (0, _concernFormContext.useConcernForm)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const form = (0, _reactHookForm.useForm)({
        defaultValues: sentValues
    });
    if (!sentValues) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SUMMARY),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SubmitSuccess.SubmitSuccess, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "h4",
                        component: "h4",
                        children: translations.summary
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
                        ...form,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormContent, {})
                    })
                ]
            })
        ]
    });
};
exports.Summary = Summary;
